/* FOOT DROP — Mes favoris (coeur du systeme, Phase 1)
   Store unifie localStorage 'fdFav' v2 (cle = handle produit), migration fdcFav/fdwish,
   coeurs par delegation (survit aux morphs Horizon), badge header, toasts, calculs d'offre,
   file analytics + couche de sync FootDrop Core (activee via window.FD_CORE_URL).
   Aucune donnee sensible: handles produits + tailles + un identifiant de session aleatoire. */
(function () {
  'use strict';
  if (window.FDFav) return; /* anti double-init */
  var LS = 'fdFav', SEEN = 'fdSeen', EVT = 'fdEvt';
  function hasOwn(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }

  function lsGet(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  /* ---------- store ---------- */
  function fresh() {
    var sid = 'xxxxxxxx'.replace(/x/g, function () { return Math.floor(Math.random() * 36).toString(36); });
    try { if (window.crypto && crypto.randomUUID) sid = crypto.randomUUID(); } catch (e) {}
    return { v: 2, sid: sid, items: {} };
  }
  var S = lsGet(LS);
  if (!S || S.v !== 2 || typeof S.items !== 'object') S = fresh();

  /* migration fdcFav (objet cle '/products/<handle>') */
  var old1 = lsGet('fdcFav');
  if (old1 && typeof old1 === 'object') {
    Object.keys(old1).forEach(function (k) {
      var h = (k.split('/products/')[1] || '').split('?')[0].replace(/\/+$/, '');
      if (h && !S.items[h]) S.items[h] = { ts: Date.now(), src: 'migration' };
    });
    try { localStorage.removeItem('fdcFav'); } catch (e) {}
    lsSet(LS, S);
  }
  /* Ancienne migration fdwish retirée : les favoris actuels utilisent fdFav v2. */
  try { localStorage.removeItem('fdwish'); localStorage.removeItem('fdwishTry'); } catch (e) {}


  function save() { lsSet(LS, S); paint(); emit(); syncSoon(); }
  function emit() {
    try { document.dispatchEvent(new CustomEvent('fd:fav:change', { detail: { count: count() } })); } catch (e) {}
  }
  function count() { return Object.keys(S.items).length; }
  function has(h) { return hasOwn(S.items, h); }
  function setVariant(h, meta) { /* change de taille/variante SANS compter un nouvel ajout */
    if (!hasOwn(S.items, h)) return;
    var it = S.items[h];
    if (meta.vid) it.vid = meta.vid;
    if (meta.size) it.size = meta.size;
    it.ts = Date.now();
    save(); track('favourite_size_changed', { h: h });
  }
  function add(h, meta) {
    if (!h) return;
    var it = S.items[h] || {};
    meta = meta || {};
    S.items[h] = { vid: meta.vid || it.vid, size: meta.size || it.size, ver: meta.ver || it.ver,
                   ts: Date.now(), src: meta.src || it.src || page() };
    save(); track('favourite_added', { h: h, src: S.items[h].src });
  }
  function remove(h) {
    if (!hasOwn(S.items, h)) return;
    delete S.items[h]; save(); track('favourite_removed', { h: h });
  }
  /* multi-onglets : si un autre onglet ecrit fdFav, on se rafraichit */
  try {
    window.addEventListener('storage', function (e) {
      if (e.key !== LS) return;
      var n = lsGet(LS);
      if (n && n.v === 2 && typeof n.items === 'object') { S = n; paint(); emit(); }
    });
  } catch (e) {}
  function toggle(h, meta) {
    if (has(h)) { remove(h); toast('Retiré de tes favoris'); return false; }
    add(h, meta); toast('Ajouté à tes favoris'); return true;
  }
  function list() {
    return Object.keys(S.items).map(function (h) {
      var it = S.items[h]; return { handle: h, vid: it.vid, size: it.size, ver: it.ver, ts: it.ts, src: it.src };
    }).sort(function (a, b) { return (b.ts || 0) - (a.ts || 0); });
  }
  function page() {
    var p = location.pathname;
    if (p === '/') return 'home';
    if (p.indexOf('/collections/') === 0) return 'collection:' + p.split('/')[2];
    if (p.indexOf('/products/') === 0) return 'product';
    if (p.indexOf('/search') === 0) return 'search';
    if (p.indexOf('/pages/') === 0) return p.split('/')[2];
    return p.slice(0, 40);
  }

  /* ---------- recemment vus (independant du natif viewedProducts) ---------- */
  (function () {
    var m = location.pathname.match(/^\/products\/([a-z0-9-]+)/);
    if (!m) return;
    var seen = lsGet(SEEN) || [];
    seen = [m[1]].concat(seen.filter(function (h) { return h !== m[1]; })).slice(0, 24);
    lsSet(SEEN, seen);
  })();

  /* ---------- toast ---------- */
  var toastEl = null, toastTimer = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.id = 'fdToast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('on'); }, 1600);
  }

  /* ---------- coeurs (delegation globale, survit aux re-rendus) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-fd-heart]') : null;
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var h = btn.getAttribute('data-handle');
    if (!h) { var a = btn.closest('a[href*="/products/"]'); if (a) h = (a.pathname.split('/products/')[1] || '').split('?')[0]; }
    if (!h) return;
    toggle(h, { vid: btn.getAttribute('data-vid') || undefined });
  }, true);

  function paintBtn(btn, fav) {
    btn.classList.toggle('is-fav', fav);
    var pressed = fav ? 'true' : 'false';
    if (btn.getAttribute('aria-pressed') !== pressed) btn.setAttribute('aria-pressed', pressed);
  }
  function paint(root) {
    (root || document).querySelectorAll('[data-fd-heart]').forEach(function (btn) {
      var h = btn.getAttribute('data-handle');
      if (!h) { var a = btn.closest('a[href*="/products/"]'); if (a) { h = (a.pathname.split('/products/')[1] || '').split('?')[0]; btn.setAttribute('data-handle', h); } }
      paintBtn(btn, !!(h && S.items[h]));
    });
    var n = count();
    document.querySelectorAll('[data-fd-fav-count]').forEach(function (el) {
      var label = n > 99 ? '99+' : String(n);
      if (el.textContent !== label) el.textContent = label;
      /* seuls les BADGES (pastilles) se masquent a zero; les compteurs en texte restent visibles */
      if (el.classList.contains('fd-hd-n') || el.classList.contains('n')) {
        el.classList.toggle('show', n > 0);
        el.style.display = n > 0 ? '' : 'none';
      }
    });
  }
  var mo = null, moT = null;
  function observe() {
    if (mo || !document.body) return;
    var selector = '[data-fd-heart],[data-fd-fav-count]';
    mo = new MutationObserver(function (records) {
      var relevant = records.some(function (record) {
        if (record.type === 'attributes') return record.target.matches('[data-fd-heart]');
        return Array.prototype.some.call(record.addedNodes, function (node) {
          return node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector));
        });
      });
      if (!relevant || moT !== null) return;
      moT = setTimeout(function () { moT = null; paint(); }, 120);
    });
    mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-handle'] });
  }
  var HEART_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.4S5.8 16.4 3.4 12.9C1.7 10.3 2.5 7.2 5.1 6.1c1.8-.8 3.8-.2 5.1 1.2L12 9.1l1.8-1.8c1.3-1.4 3.3-2 5.1-1.2 2.6 1.1 3.4 4.2 1.7 6.8C18.2 16.4 12 20.4 12 20.4z"/></svg>';
  function heartHTML(handle, extraClass) {
    return '<button type="button" class="fd-heart ' + (extraClass || '') + '" data-fd-heart data-handle="' + handle +
           '" aria-label="Garder ce maillot" aria-pressed="false">' + HEART_SVG + '</button>';
  }

  /* ---------- produits live (cache court 90s ; null cache uniquement sur vrai 404) ---------- */
  function fetchProduct(handle) {
    var ck = 'fdPd:' + handle, c = null;
    try { c = JSON.parse(sessionStorage.getItem(ck)); } catch (e) {}
    if (c && Date.now() - c.t < 90000) return Promise.resolve(c.p);
    return fetch('/products/' + handle + '.js').then(function (r) {
      if (r.status === 404) {
        try { sessionStorage.setItem(ck, JSON.stringify({ t: Date.now(), p: null })); } catch (e) {}
        return null;
      }
      if (!r.ok) return (c ? c.p : null); /* erreur transitoire: pas de cache, on garde l'ancien si present */
      return r.json().then(function (p) {
        try { sessionStorage.setItem(ck, JSON.stringify({ t: Date.now(), p: p })); } catch (e) {}
        return p;
      });
    }).catch(function () { return c ? c.p : null; });
  }

  /* ---------- eligibilite + calcul d'offre (miroir des discounts reels) ---------- */
  var EXCLU = ['Manches Longues', 'Femme', 'Enfant', 'Rétro', 'Ensemble'];
  function isEligible(tags) {
    tags = tags || [];
    if (tags.indexOf('Maillot individuel') < 0) return false;
    for (var i = 0; i < EXCLU.length; i++) if (tags.indexOf(EXCLU[i]) >= 0) return false;
    return true;
  }
  function isProVariant(variant) {
    if (!variant) return false;
    var opts = variant.options || [];
    for (var i = 0; i < opts.length; i++) if (/pro/i.test(String(opts[i]))) return true;
    return false;
  }
  function euros(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }
  /* sel = [{price(cents), eligible(bool)}] ; club = avantage membre dispo */
  function computeOffer(sel, club) {
    var elig = sel.filter(function (x) { return x.eligible; });
    var n = elig.length, target = club ? 4 : 3;
    var freeCount = Math.floor(n / 3);
    if (club && n >= 4) freeCount = 1 + Math.floor((n - 1) / 3);
    var prices = elig.map(function (x) { return x.price; }).sort(function (a, b) { return a - b; });
    var freeValue = prices.slice(0, freeCount).reduce(function (a, b) { return a + b; }, 0);
    var totalAll = sel.reduce(function (a, x) { return a + x.price; }, 0);
    var total = totalAll - freeValue;
    var msg, ready = false;
    if (club) {
      if (n <= 0) msg = 'Sélectionne des maillots éligibles';
      else if (n < 4) msg = 'Encore ' + (4 - n) + ' maillot' + (4 - n > 1 ? 's' : '') + ' : ton avantage membre t’attend';
      else { msg = 'Ton avantage membre est disponible — 2 achetés, 2 offerts'; ready = true; }
    } else {
      if (n <= 0) msg = 'Sélectionne des maillots éligibles';
      else if (n === 1) msg = 'Encore 2 maillots pour profiter de l’offre';
      else if (n === 2) msg = 'Encore 1 maillot pour compléter le lot 2 + 1 offert';
      else { msg = freeCount + ' maillot' + (freeCount > 1 ? 's offerts' : ' offert') + ' prévu' + (freeCount > 1 ? 's' : '') + ' — 1 offert tous les 2 achetés'; ready = true; }
    }
    /* prix unitaire affiche UNIQUEMENT si la division tombe juste (promesse de montants exacts) */
    var perTxt = '';
    if (freeCount > 0 && sel.length > 0 && total % sel.length === 0) perTxt = euros(total / sel.length);
    return { n: n, target: target, freeCount: freeCount, freeValue: freeValue,
             total: total, totalTxt: euros(total), perTxt: perTxt,
             message: msg, ready: ready, missing: Math.max(target - n, 0) };
  }

  /* ---------- ajout groupe au panier ---------- */
  function addAllToCart(items) { /* items = [{id: variantId, quantity: 1}] */
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); return r.json(); });
  }

  /* ---------- analytics (file locale + Core si configure) ---------- */
  function track(type, data) {
    var q = lsGet(EVT) || [];
    q.push({ t: type, d: data || {}, at: Date.now() });
    if (q.length > 200) q = q.slice(-200);
    lsSet(EVT, q);
    try { if (window.dataLayer) window.dataLayer.push({ event: 'fd_' + type, fd: data || {} }); } catch (e) {}
    flushSoon();
  }
  var flushT = null;
  function flushSoon() { clearTimeout(flushT); flushT = setTimeout(flushEvents, 4000); }
  function flushEvents() {
    if (!window.FD_CORE_URL) return;
    var q = lsGet(EVT) || [];
    if (!q.length) return;
    var payload = JSON.stringify({ sid: S.sid, events: q });
    var ok = false;
    try { ok = navigator.sendBeacon(window.FD_CORE_URL + '/v1/events', payload); } catch (e) {}
    if (ok) lsSet(EVT, []);
  }

  /* ---------- sync FootDrop Core (Phase 2 — no-op tant que FD_CORE_URL absent) ---------- */
  var syncT = null;
  function wireItems() { /* format API Core: [{handle, variant, size, at}] */
    return list().map(function (f) {
      return { handle: f.handle, variant: f.vid || null, size: f.size || null, at: f.ts || Date.now() };
    });
  }
  function syncSoon() { clearTimeout(syncT); syncT = setTimeout(sync, 2500); }
  function sync() {
    if (!window.FD_CORE_URL) return;
    fetch(window.FD_CORE_URL + '/v1/fav/sync', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sid: S.sid, items: wireItems() })
    }).catch(function () {});
  }
  function mergeToCustomer(customerToken) { /* appele par la page favoris/membre quand connecte */
    if (!window.FD_CORE_URL || !customerToken) return Promise.resolve(null);
    return fetch(window.FD_CORE_URL + '/v1/fav/merge', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sid: S.sid, customer: customerToken, items: wireItems() })
    }).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (res) {
        if (res && res.items && res.items.forEach) { /* le serveur renvoie l'union en tableau */
          res.items.forEach(function (it) {
            if (it && it.handle && !hasOwn(S.items, it.handle)) {
              S.items[it.handle] = { vid: it.variant || undefined, size: it.size || undefined, ts: it.at || Date.now(), src: 'merge' };
            }
          });
          lsSet(LS, S); paint(); emit();
          track('anonymous_favourites_merged', { added: res.added || 0 });
        }
        return res;
      }).catch(function () { return null; });
  }

  /* ---------- boot ---------- */
  function boot() { paint(); observe(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.FDFav = {
    has: has, add: add, remove: remove, toggle: toggle, list: list, count: count,
    setVariant: setVariant, heartHTML: heartHTML, paint: paint, toast: toast, fetchProduct: fetchProduct,
    isEligible: isEligible, isProVariant: isProVariant, computeOffer: computeOffer,
    euros: euros, addAllToCart: addAllToCart, track: track, merge: mergeToCustomer,
    seen: function () { return lsGet(SEEN) || []; }, sid: function () { return S.sid; }
  };
  try { document.dispatchEvent(new CustomEvent('fd:ready')); } catch (e) {}
})();

